import axios from 'axios';

// 创建 axios 实例
const service = axios.create({
  // baseURL: 'http://localhost:5001',
  baseURL: 'https://h5.guangzhoutaixie.com/xhapi',
  timeout: 5000
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在这里可以添加请求头等配置
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 200) {
      return res;
    }
    console.error('接口返回错误:', res.message || '未知错误');
    return Promise.reject(new Error(res.message || '未知错误'));
  },
  error => {
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

export default service; 